import { Icon } from "@iconify/react"
import { Button, Card, Flex, Grid, Input, message, Pagination, Table, Tag } from "antd"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import useTitleStore from "../../../store/titleStore";
import { useTableHeight } from "../../../hooks/useTableHeight";
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useDebounce from "../../../hooks/useDebounce";
import { officeService } from "../../../services/office.service";
import UpdatedByCell from "../../../components/UpdatedByCell";
import TableAction from "../../../components/TableAction";

export default function ServiceOfficeIndex(){

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  const tableHeight = useTableHeight();
  const queryClient = useQueryClient();

  const [messageApi, contextHolder] = message.useMessage();
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: []
  })

  useEffect(() => {
    setTitle("Kantor Pelayanan");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: office , isLoading } = useQuery({
    queryKey: ['office', dataParams],
    queryFn: () => officeService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  })

  const deleteMutation = useMutation({
    mutationFn: (id) => officeService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries('office');
      messageApi.success('Data berhasil dihapus');
    },
    onError: (error) => {
      console.log(error)
    }
  })

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      filter: [
        {
          field: 'urbanVillage',
          operator: 'like',
          value: debouncedKeyword
        }
      ]
    }));
  }, [debouncedKeyword]);

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 40,
      render: (text, record, index) =>  index + 1,
      fixed: breakpoint.md &&  'left'
    },
    {
      title: 'Kelurahan',
      dataIndex: 'urbanVillage',
      width: 210,
    },
    {
      title: 'Regional',
      dataIndex: 'regional',
      width: 150,
      render: val => {
        switch (val) {
          case 'Pusat':
            return <Tag color="cyan" >Pusat</Tag>
          case 'Timur':
            return <Tag color="green" >Timur</Tag>
          case 'Barat & Selatan':
            return <Tag color="gold" >Barat & Selatan</Tag>
          case 'Utara':
            return <Tag color="red" >Utara</Tag>
        }
      }
    },
    {
      title: 'Area Bisnis',
      dataIndex: 'ab',
      width: 150,
      render: val => val.NAMA_AB
    },
    {
      title: 'Tanggal Update',
      width: 210,
      render: val => <UpdatedByCell value={val} />,
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 120,
      fixed: 'right',
      render: record => (
        <TableAction
          handleDelete={() => deleteMutation.mutate(record.id)}
          deleteLoading={deleteMutation.isPending}
          onClickEdit={() => navigate(`/customer-care/office/detail/${record.id}`)}
        />
      )
    },
  ]

  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0
        }
      }}
    >
      {contextHolder}
      <Flex justify="space-between" style={{ paddingInline: 24, marginBottom: 24 }} gap={20} >
        <Input 
          style={{ width: 320 }} 
          prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
          placeholder="cari..."
          onChange={e => setKeyword(e.target.value)}
          value={keyword}
        />
        <Button 
          variant="solid" 
          color="primary"  
          icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
          onClick={() => navigate('/customer-care/office/create')}
          style={{ marginLeft: !breakpoint.md && 'auto', minWidth: 38 }}
        >
          {breakpoint.md && 'Tambah Kantor Pelayanan'}
        </Button>
      </Flex>
      <Table
        loading={isLoading}
        columns={columns}
        pagination={false}
        size="small"
        rowKey={'id'}
        scroll={{ y: tableHeight }}
        dataSource={office?.data}
      />
      <Pagination
        style={{ marginInline: 24, marginTop: 16 }}
        total={office?.pagination?.total}
        showSizeChanger={{
          showSearch: false,
        }}
        pageSizeOptions={['10', '20', '50']}
        current={office?.pagination?.page}
        pageSize={dataParams.limit}
        align="end"
        onChange={handleChangePage}
      />
    </Card>
  )
}